import ApiUrl from "../../../helpers/ApiUrl";
import { get } from "../../../helpers/ApiServices";

export const formReportApi = {
  async getFormCompletionMetrics() {
    try {
      const response = await get(ApiUrl.getFormCompletionMetrics, "", "");
      return { success: true, data: { result: response.data.result } };
    } catch (error) {
      return {
        success: false,
        data: {
          message: error.message || "Failed to fetch form completion metrics"
        }
      };
    }
  },

  async getFormTotalCompletion(formId) {
    try {
      const response = await get(
        ApiUrl.getFormTotalCompletion + formId,
        "",
        ""
      );
      return { success: true, data: { result: response.data.result } };
    } catch (error) {
      return {
        success: false,
        data: {
          message: error.message || "Failed to fetch form total completion"
        }
      };
    }
  },

  async getFormCompletionResponses(formId) {
    try {
      const response = await get(
        ApiUrl.getFormCompletionResponses + formId,
        "",
        ""
      );
      return { success: true, data: { result: response.data.result } };
    } catch (error) {
      return {
        success: false,
        data: {
          message: error.message || "Failed to fetch form completion responses"
        }
      };
    }
  },

  async getFormCompletionDetail(formId) {
    try {
      const response = await get(ApiUrl.getFormCompletionMetrics + formId, "", "");
      return { success: true, data: { result: response.data.result } };
    } catch (error) {
      return {
        success: false,
        data: { message: error.message || "Failed to fetch form completion detail" }
      };
    }
  },
  async getFromCompletionResponses(id) {
    try {
      const response = await get(ApiUrl.getFormMetrics + id, "", "");
      return { success: true, data: { result: response.data.result } };
    } catch (error) {
      return { success: false, data: { message: error.message || "Failed to fetch form completion responses" } };
    }
  }
};
